import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUser } from '../../interfaces/toolbar/toolbar.interface';
@Injectable({
  providedIn: 'root',
})
export class PasskeysService {
  constructor(private http: HttpClient) {}

  getCredentials(url: string, userInfo: IUser) {
    return this.http.get(
      `${url}/options-auth/${userInfo?.username}:users/${userInfo?.username}:current/generation`
    );
  }

  createRegistration(url: string, userInfo: IUser) {
    return this.http.post(
      `${url}/registration/${userInfo.username}:users/${userInfo.username}:current`,
      {
        displayName: 'Cell phone',
      }
    );
  }

  verifyRegistration(
    url: string,
    userInfo: IUser,
    infoUserPasskey: any,
    challenge: string,
    registration: any
  ) {
    return this.http.post(
      `${url}/registration/${userInfo.username}:users/${userInfo.username}:current/verification`,
      {
        challenge,
        registration,
        userInfo: infoUserPasskey,
      }
    );
  }

  editPasskey(
    url: string,
    userInfo: IUser,
    displayName: string,
    credentialID: string
  ) {
    return this.http.patch(
      `${url}/users/${userInfo.username}:users/${userInfo.username}:current/passkey/modification`,
      {
        displayName,
        credentialID,
      }
    );
  }
  deletePasskey(url: string, userInfo: IUser, credentialID: string) {
    return this.http.patch(
      `${url}/users/${userInfo.username}:users/${userInfo.username}:current/passkey`,
      {
        credentialID,
      }
    );
  }
}
